import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SewTabBar, SewTabBarItem } from '@sew/ui-components-angular/standalone';
import { PartGroupRow } from '../part-table/part-table.interface';
import { CustomTab } from './group-toggle.interface';

@Component({
    selector: 'ecs-group-toggle',
    templateUrl: './group-toggle.component.html',
    styleUrls: ['./group-toggle.component.scss'],
    imports: [TranslatePipe, SewTabBar, SewTabBarItem],
})
export class GroupToggleComponent {
    @Input() public groups: readonly PartGroupRow[] | null = null;
    @Input() public customTabs?: readonly CustomTab[];

    @Output() public groupSelect = new EventEmitter<PartGroupRow | undefined>();
    @Output() public customTabSelect = new EventEmitter<number>();

    public selectedGroup: PartGroupRow | undefined;

    public selectGroup(group: PartGroupRow | undefined) {
        this.selectedGroup = group;
        this.groupSelect.emit(this.selectedGroup);
    }

    public selectCustomTab(index: number) {
        this.customTabSelect.emit(index);
    }
}
